import { httpClient } from './httpClient';

export interface CarouselItem {
  id?: number;
  title: string;
  subtitle?: string;
  description?: string;
  imageData: string;
  imageType?: string;
  sortOrder?: number;
  status?: string;
  createBy?: string;
  createTime?: string;
  updateBy?: string;
  updateTime?: string;
  remark?: string;
}

export interface CarouselListParams {
  title?: string;
  subtitle?: string;
  status?: string;
  pageNum?: number;
  pageSize?: number;
}

export interface CarouselListResponse {
  records: CarouselItem[];
  total: number;
  current: number;
  size: number;
}

class CarouselService {
  /**
   * 获取轮播图片列表
   */
  async getList(params: CarouselListParams = {}): Promise<CarouselListResponse> {
    const response = await httpClient.get('/api/carousel/list', { params });
    return response.data;
  }

  /**
   * 获取启用的轮播图片列表（用于前端展示）
   */
  async getEnabledList(): Promise<CarouselItem[]> {
    const response = await httpClient.get('/api/carousel/enabled');
    
    // 检查响应结构
    if (response.data && response.data.code === 200 && response.data.data) {
      return response.data.data;
    } else if (Array.isArray(response.data)) {
      return response.data;
    } else {
      return [];
    }
  }

  /**
   * 获取轮播图片详情
   */
  async getDetail(id: number): Promise<CarouselItem> {
    const response = await httpClient.get(`/api/carousel/${id}`);
    return response.data;
  }

  /**
   * 新增轮播图片
   */
  async create(data: Omit<CarouselItem, 'id'>): Promise<void> {
    await httpClient.post('/api/carousel', data);
  }

  /**
   * 更新轮播图片
   */
  async update(data: CarouselItem): Promise<void> {
    await httpClient.put('/api/carousel', data);
  }

  /**
   * 删除轮播图片
   */
  async delete(ids: number[]): Promise<void> {
    await httpClient.delete(`/api/carousel/${ids.join(',')}`);
  }
}

export const carouselService = new CarouselService();
